import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface AnchorProps {
    id: string;
}

const Anchor: React.FC<AnchorProps> = ({ children, id }): JSX.Element => {
    const classes = useStyles();

    return (
        <div id={id} className={classes.anchor}>
            {children}
        </div>
    );
};

//=====================================//
//=============== Style ===============//
//=====================================//

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        anchor: {
            display: 'block',
            position: 'relative',
            top:
                -theme.mixins.toolbar.minHeight -
                document.getElementById('header')?.getBoundingClientRect()?.height -
                40,
            visibility: 'hidden',
        },
    }),
);

export default Anchor;
